import { gql } from "@apollo/client";

export const GET_PRESCRIPTION_TEMPLATE = gql`
  query PrescriptionTemplate($id: ID!) {
    prescriptionTemplate(id: $id) {
      id
      siteGroupTemplate {
        id
        name
        siteGroupRules {
          id
          field {
            id
            name
          }
          defaultValue
          isShown
          isActive
          isSelectedForBulkEdit
        }
        siteTemplate {
          id
          site {
            id
            name
          }
          ruleSite {
            id
            field {
              id
              name
            }
            defaultValue
            isShown
            isActive
            isSelectedForBulkEdit
          }
        }
      }
      volumingRules {
        id
        field {
          id
          name
        }
        defaultValue
        isShown
        isActive
        isSelectedForBulkEdit
      }
    }
  }
`;

export const UPDATE_VOLUMING_RULE = gql`
  mutation updateVolumingRule(
    $groupId: ID!
    $fieldName: String!
    $defaultValue: String
    $isShown: Boolean
    $isActive: Boolean
    $isSelectedForBulkEdit: Boolean
  ) {
    updateVolumingRule(
      groupId: $groupId
      fieldName: $fieldName
      defaultValue: $defaultValue
      isShown: $isShown
      isActive: $isActive
      isSelectedForBulkEdit: $isSelectedForBulkEdit
    ) {
      volumingRule {
        id
        field {
          id
          name
        }
        defaultValue
        isShown
        isActive
        isSelectedForBulkEdit
      }
    }
  }
`;

export const DELETE_PRESCRIPTION = gql`
  mutation deletePrescriptionTemplate($prescriptionId: ID!) {
    deletePrescriptionTemplate(prescriptionId: $prescriptionId) {
      ok
    }
  }
`;

export const CREATE_PRESCRIPTION = gql`
  mutation createPrescriptionTemplate($templateId: ID!, $name: String!) {
    createPrescriptionTemplate(templateId: $templateId, name: $name) {
      prescriptionTemplate {
        id
      }
    }
  }
`;
